module.exports = __webpack_public_path__ + "media/components/shared/header/static/header_logo-7e3600e0647068028b4c0dc19df4a186.svg";